import { UI, HStack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Box, Button, IStackProps } from 'native-base';
import React from 'react';
import { Pressable } from 'react-native';

import { getValidatedStatusIcon } from '../../../../../utils/getValidatedStatusIcon';
import { BasketLink } from '../../../../OrderHistoryModal/components/BasketLink';
import { OrderFullStatus } from '../../../../OrderHistoryModal/components/OrderFullStatus';
import { messageError } from '../../constants';

import {
  OrderHistoryItemComponentProps,
  formatDate,
  formatMoney,
  handleExportNewOrder,
} from './constants';

interface TableItemProps {
  label: string;
  value: string | React.ReactNode;
  maxW?: IStackProps['maxW'];
  valueUppercase?: boolean;
}

export const TableItem = ({ label, value, maxW, valueUppercase }: TableItemProps) => {
  const valueIsString = typeof value === 'string';

  return (
    <VStack space={Spacing['stack.quarck']} w={maxW} maxW={maxW}>
      <UI.Text variant="semibold" color="neutral.black">
        {label}
      </UI.Text>
      {valueIsString ? (
        <UI.Text textTransform={valueUppercase ? 'uppercase' : 'inherit'}>{`${value}`}</UI.Text>
      ) : (
        value
      )}
    </VStack>
  );
};

export const OrderHistoryItemTablet = ({
  item,
  onSelect,
  isReferencedByBasket,
  onBasketPress,
}: OrderHistoryItemComponentProps) => {
  const orderAmount = formatMoney(item?.requestedAmount);

  const sendOrderDate = formatDate(item?.orderDate);

  const statusItem = getValidatedStatusIcon(item.orderStatus.statusIcon);

  return (
    <UI.Shadow
      testId="table-item-tablet"
      level={1}
      marginY={Spacing['stack.nano']}
      borderRadius={BoxBorder.heavy}>
      <VStack py={Spacing['stack.xxxs']} px={Spacing['inline.xxs']}>
        <HStack alignItems="center">
          <HStack space={Spacing['inline.xxxs']} alignItems="center" w="1/4">
            <Pressable
              testID="order-history-button-icon"
              onPress={() => handleExportNewOrder(item)}>
              <UI.Icon name="Pdf" size="xs" color={Color['brand.tertiary.principal']} />
            </Pressable>
            <TableItem label="ID Ordem" value={item?.orderHash || messageError} />
          </HStack>
          <HStack space={Spacing['inline.nano']} alignItems="center" w="1/4">
            <TableItem
              label="ID Cesta"
              value={
                isReferencedByBasket
                  ? item?.basketDetail?.basketAdvisorOrderHash || messageError
                  : messageError
              }
            />
            {isReferencedByBasket && <BasketLink onPress={onBasketPress} />}
          </HStack>
          <HStack w="full" maxW={'1/4'}>
            <TableItem
              label="Tipo"
              valueUppercase
              value={item?.sideDescription || messageError}
              maxW="160px"
            />
          </HStack>
          <TableItem label="Data de envio" value={sendOrderDate} maxW="1/4" />
        </HStack>
        <Box w="full" h="1px" bgColor={Color['neutral.lightest']} my={Spacing['inline.nano']} />
        <HStack alignItems="center">
          <HStack w="full" maxW={'1/4'}>
            <TableItem
              label="Cliente"
              value={item.customer.customerName || messageError}
              maxW="160px"
            />
          </HStack>
          <TableItem
            label="Produto"
            value={item.marketType || messageError}
            valueUppercase
            maxW="1/4"
          />
          <TableItem label="Valor enviado" value={orderAmount} maxW="1/4" />
          <HStack w="1/4" justifyContent="space-between" alignItems="center">
            <TableItem
              label="Status"
              value={
                <OrderFullStatus statusIcon={statusItem} statusMessage={item.orderStatus.status} />
              }
            />
            <Button
              color={Color['brand.tertiary.principal']}
              variant="textLink"
              onPress={() => onSelect(item)}
              rightIcon={
                <UI.Icon name="ArrowRight" size="xxs" color={Color['brand.tertiary.principal']} />
              }
            />
          </HStack>
        </HStack>
      </VStack>
    </UI.Shadow>
  );
};

export default OrderHistoryItemTablet;
